export enum RegistryRoleEnum {
  SUPERADMIN = "superadmin",
  ADMIN = "admin",
  BASIC = "basic",
}